import React, { Component } from 'react'
import { MuiGrid, MuiButton, MuiTypography } from '../../../../../ui'
import { gradePickerUtil } from '../../../../gradePicker'
import theme from '../../../../../../assests/theme'
import spinner from "../../../../../ui/icons/spinner.gif";
import * as StringReplacer from '../../../../../../i18n/StringReplacer'

class JointClassComponent extends Component {
    constructor(props) {
        super(props)
        this.state = {

        }
    }
    getDisplayText = () => {
        const i18n = this.props.i18n

        let gradeString = gradePickerUtil.displayingGradeDetailString_Rules(this.props.gradeDetails, this.props)
        let displayString = StringReplacer.getFormatedMessage(i18n.jointClassConstraints.displayString,
            {
                Subject: this.props.jointClasses.subjectName || this.props.jointClasses.electiveName,
                Grade: gradeString,
            })
        return displayString;
    }
    render() {
        const { i18n } = this.props

        return (
            <React.Fragment>
                {this.props.filter.showSections === false ?
                    <React.Fragment>
                        <MuiGrid container style={{ paddingBottom: "10px" }}>
                            <MuiTypography style={theme.typography.h6} gutterBottom>
                                {i18n.jointClassConstraints.jointClassIsOnlyForSections}
                            </MuiTypography>
                        </MuiGrid>

                        {/* cancel button */}
                        <MuiGrid container justify="flex-end" style={{ marginTop: "10px", paddingTop: "10px", borderTop: "1px solid " + theme.palette.grey.main }}>

                            <MuiGrid item style={{ marginRight: "10px" }}>
                                <MuiButton style={theme.secondaryButtonStyle} onClick={() => { this.props.handleCloseForDialog() }}>
                                    {i18n.commonTexts.cancel}
                                </MuiButton>
                            </MuiGrid>
                        </MuiGrid>
                    </React.Fragment>
                    :
                    <React.Fragment>
                        {/* Display the selected classes*/}
                        < MuiGrid container style={{ paddingBottom: "10px" }}>
                            <MuiTypography style={theme.typography.h6} gutterBottom>
                                {this.getDisplayText()}
                            </MuiTypography>
                        </MuiGrid>

                        {/* Buttons  */}
                        <MuiGrid container justify="flex-end" style={{ marginTop: "10px", paddingTop: "10px", borderTop: "1px solid " + theme.palette.grey.main }}>

                            <MuiGrid item style={{ marginRight: "10px" }}>
                                <MuiButton style={theme.secondaryButtonStyle} onClick={() => { this.props.handleCloseForDialog() }}>
                                    {i18n.commonTexts.cancel}
                                </MuiButton>
                            </MuiGrid>

                            <MuiGrid item>
                                {this.props.updateSchoolinformationInProgress ? <img src={spinner} alt="none" style={theme.spinnerImgStyleForButton} /> :
                                    <MuiButton disabled={this.props.disableEdit} style={this.props.disableEdit ? theme.primaryButtonDisabledStyle : theme.primaryButtonStyle} onClick={() => { this.props.onClickOfSave() }}>
                                        {i18n.commonTexts.apply}
                                    </MuiButton>}
                            </MuiGrid>
                        </MuiGrid>
                    </React.Fragment>
                }

            </React.Fragment>
        )
    }
}
export default JointClassComponent